import React, { Component } from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import { openPhonecall } from "../../common/callUtil"
//import {  hideChat } from "../../lib/synalio";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";

const modal_reservation_impl = props => {
  console.log('modal_reservation', props);
  const { asset, room, eventTrackingId, type } = props;
  //hideChat();

  const formUrl = '/hello-storage/contact/' + (asset ? '?object_cd=' + asset.assetId : '') + (room ? '&dev_mng_no=' + room.roomId : '') + '&contact=reservation';
  // {room ? ' ' + room.roomName : ''}
console.log(formUrl);
  return (
    <div className="modal_reservation modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title" style={{ "white-space": "pre-wrap" }}>
        <br/>
        {asset.name}　{room.roomName}号室({room.floor}階)　{room.extent}(帖)<br/>
        {room.riyouKikanEnd.replace(/-/g, "/") + "　空き予定"}
      </div>
      <div className="collection" id="contact_select">
        <a
          href={formUrl}
          target="_blank"
          className="item link"
        >
          <div>空き待ち登録</div>
        </a>
      </div>
      <div className="collection_footer" style={{ "white-space": "pre-wrap" }}>
        {asset.webDiscount.text2}
      </div>
    </div>
  );
};

export const modal_reservation = props => {
  return <MasterDataReady schemaIds={["excComment"]} render={() => {
    if (isVisibleContent(masterData.excComment.modalVisitor)) {
      const { type } = props;
      return (
        <div className="modal_reservation modal_base">
          <div className="cross" onClick={() => modal.closeModal()} />
          <DynamicContent params={masterData.excComment.modalVisitor} type={type}></DynamicContent>
        </div>
      );
    } else {
      return modal_reservation_impl(props);
    }
  }}>
  </MasterDataReady>
};



// WEBPACK FOOTER //
// ./common/modal/modal_reservation.jsx